import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { generatePath } from 'react-router-dom';
import { Downgraded, useState } from '@hookstate/core';
import {
    Box,
    // CircularProgress,
    Slide
} from '@mui/material';
import TransportNote from './transportNote';
import SelectTransportation from './selectTransportation';
import { useAuthState } from '../../../stores/authStore';
import { useEventState } from '../../../stores/eventStore';
import RouteConstants from '../../../constants/routeConstants';
import APIURLConstants from '../../../config/config';
import ApiHelper from '../../../utility/ApiHelper';
import Helper from '../../../utility/helper';
import CustomizedSnackbars from '../../../sharedcomponents/snackbar/snackBar';
import ConfirmationDialog from '../../../sharedcomponents/confirmationdialog/confirmationDialog';
import PendingActionDialog from '../../../sharedcomponents/confirmationdialog/pendingActionDialog';
import { FULL_PERMISSION, VIEW_PERMISSION, REQUEST_STATUS_LIST } from '../../../constants/Constant';
import { NO_ACCESS_PERMISSION } from '../../../constants/Constant';
import UnauthorizedUI from '../../../sharedcomponents/emptyStateContainer/unauthorizedUI';
import AccordianCommonRequests from '../../../sharedcomponents/commonRequest/accordianCommonRequest';
import CustomDialog from '../../../sharedcomponents/dialog/dialog';
import StyledTable1 from '../../../sharedcomponents/styledTable/styleTable1';
import AppConstants from '../../../constants/appConstants';
import DataList from '../../../sharedcomponents/dataList/dataList';


// const loader = {
//     display: 'flex',
//     justifyContent: 'center',
//     alignItems: 'center',
//     height: '100%',
//     width: '100%',
// };
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
// const groundHeaders = [
//     { key: 'vehicleType', title: 'Vehicle Type' },
//     { key: 'participant', title: 'Name' },
//     { key: 'email', title: 'Email' },
//     { key: 'contactNo', title: 'Contact Number' },
//     { key: 'pickupDate', title: 'Start Date' },
//     { key: 'pickupAddress', title: 'Pickup Location' },
//     { key: 'dropoffDate', title: 'DropOff Date' },
//     { key: 'dropoffAddress', title: 'DropOff Location' },
//     { key: 'shared', title: 'Shared' },
//     { key: 'auditBy', title: 'Audit By' },
//     { key: 'auditDate', title: 'Audit Date' },
//     { key: 'auditStatus', title: 'Audit Status' },
//     { key: 'requestStatus', title: 'Status' }
// ]
const groundHeaders = [
    { key: 'IsGroundTransport', title: 'Ground Transport Needed' },
    { key: 'pickupAddress', title: 'Pickup Address' },
    { key: 'dropoffAddress', title: 'Drop-off Address' },
    { key: 'shared', title: 'Shared' },
    { key: 'auditBy', title: 'Audit By' },
    { key: 'auditDate', title: 'Audit Date' },
    { key: 'auditStatus', title: 'Audit Status' },
    { key: 'requestStatus', title: 'Status' }
]

const airHeaders = [
    { key: 'transportType', title: 'Transport Type' },
    { key: 'tripInfoType', title: 'Trip Info Type' },
    { key: 'passengerName', title: 'Passenger Name' },
    { key: 'passengerEmail', title: 'Passenger Email' },
    { key: 'passengerContactNo', title: 'Passenger Contact No' },
    { key: 'gender', title: 'Gender' },
    { key: 'shared', title: 'Shared' },
    { key: 'totalPassengers', title: 'No Of People Travelling' },
    { key: 'dob', title: 'DOB' },
    { key: 'airline', title: 'Preferred AirLine' },
    { key: 'flightNo', title: 'Frequent Flyer' },
    { key: 'arrivalAirport', title: 'Arrival Airport' },
    { key: 'departureAirport', title: 'Departure Airport' },
    { key: 'dateTime', title: 'Date/Time' },
    { key: 'tsa', title: 'Tsa' },
    { key: 'comments', title: 'Comments' },    
    { key: 'auditBy', title: 'Audit By' },
    { key: 'auditDate', title: 'Audit Date' },
    { key: 'auditStatus', title: 'Audit Status' },
    { key: 'requestStatus', title: 'Status' }
]

const DraftTransportList = () => {
    const showSearch = true;
    const openDialog = useState(false);
    const transittype = useState(null);
    const eventState = useEventState();
    const history = useHistory();
    const authState = useAuthState();
    const loading = useState(false);
    const approveLoader = useState(false);
    const rejectLoader = useState(false)
    const allData = useState();
    const fullData = useState([]);
    const allListData = useState([]);
    const eventData = useState(null);
    const userID = useState(null);
    const openNoteDialog = useState(false);
    const requestNote = useState(null);
    const requestPending = useState(null);
    const filteredList = useState([]);
    const [showHistory, setShowHistory] = React.useState(false);
    const [transportHistory, setTransportHistory] = React.useState()
    const [headers, setHeaders] = React.useState([]);
    const [allNoteValue, setAllNoteValue] = React.useState('')
    const [filters, setFilters] = React.useState(null);
    const statusList = useState(REQUEST_STATUS_LIST);
    const setAll = useState(false);
    const [showSearchRec, setShowSearchRec] = React.useState(false);
    const [modPermission, setModPermission] = React.useState(null);
    const [filterChangeVal, setFilterChangeVal] = React.useState(false)
    const [participantList, setParticipantList] = React.useState(null);
    const allNote = useState(false)
    const displayName = useState(null);
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });

    const pagingInfo = useState({
        currentPage: 1,
        itemsPerPage: null,
        noOfPages: null,
    });
    const approveConfirmation = useState({
        open: false,
        title: '',
        message: '',
    });
    const rejectConfirmation = useState({
        open: false,
        title: '',
        message: '',
    });
    const deleteConfirmation = useState({
        open: false,
        title: '',
        message: '',
    });

    const pendingAction = useState({
        open: false,
        title: '',
        message: '',
    });
    const [showStatus, setShowStatus] = React.useState({
        Approved: 0,
        Pending: 0,
        Rejected: 0
    });
    const approveloading = useState({
        loading: false,
        index: 0
    })
    const rejectloading = useState({
        loading: false,
        index: 0
    })
    useEffect(() => {

        const eventInfo = Helper.getStorage('eventInfo');
        const userInfo = Helper.getStorage('userInfo');
        if (
            userID.get() == null &&
            (eventData.get() == null ||
                (eventData.get() &&
                    eventData.eventID.value != eventInfo.eventID))
        ) {
            eventData.set(eventInfo);
            eventInfo.moduleDetails.filter((x) => x.moduleID === AppConstants.EVENT_MODULES.DRAFT_TRANSPORTATION).map((item) => {
                displayName.set(item.displayName)
            })
            userID.set(userInfo.userID);
        }
        if (Helper.isAdminUser(userInfo) || Helper.isEventAdmin(userInfo) || Helper.isEventStaff(userInfo)) {
            setModPermission(FULL_PERMISSION);
        } else {
            setModPermission(VIEW_PERMISSION);
        }
        const authStateInfo = authState
            .nested('appDetails')
            .attach(Downgraded)
            .get();
        if (
            authState &&
            authStateInfo &&
            authStateInfo.itemsPerPage &&
            pagingInfo.get().itemsPerPage == null
        ) {
            pagingInfo.set({
                ...pagingInfo,
                currentPage: 1,
                itemsPerPage: authStateInfo.itemsPerPage,
                noOfPages: null,
            });
        }
    }, [authState]);
    useEffect(() => {
        const userInfo = Helper.getStorage('userInfo');
        if (Helper.isAdminUser(userInfo)) {
            pagingInfo.set({
                ...pagingInfo,
                currentPage: 1,
                itemsPerPage: 5000,
                noOfPages: pagingInfo.get().noOfPages,
            });
        }
    }, [])
    useEffect(() => {
        const userInfo = Helper.getStorage('userInfo');
        if (eventState && eventState.eventDetail.get()) {
            if (Helper.isAdminUser(userInfo) || Helper.isEventStaff(userInfo)) {
                setModPermission(FULL_PERMISSION);
            } else if (userInfo.roles && Helper.isEventAdmin(userInfo)) {
                const permissions = eventState.permissions
                    .attach(Downgraded)
                    .get();
                if (permissions && permissions.length > 0) {
                    setModPermission(
                        Helper.getModuleAccessPermission(
                            permissions,
                            'TRANSPORTATION'
                        )
                    );
                }
            }
        }
    }, [eventState]);

    useEffect(() => {
        if (modPermission && modPermission != NO_ACCESS_PERMISSION) {
            const pageInfo = pagingInfo.attach(Downgraded).get();
            if (pageInfo.itemsPerPage) {
                getAdminTransportList();
            }
            getParticipantList();
        }
    }, [modPermission]);

    const getAdminTransportList = () => {
        loading.set(true);
        let participantList = [];
        ApiHelper.get(
            APIURLConstants.GET_ADMIN_DRAFT_TRANSPORT_LIST(
                eventData.get().eventID,
                1,
                5000
            )
        )
            .then((res) => {
                if (res.data.rows) {
                    let data = res.data.rows;
                    let requestData = [];
                    let allrequestData = [];
                    const indexOfLastRecord = pagingInfo.get().currentPage * pagingInfo.get().itemsPerPage;
                    const indexOfFirstRecord = indexOfLastRecord - pagingInfo.get().itemsPerPage;
                    if (data.length > 0) {
                        let approved = 0;
                        let pending = 0;
                        let rejected = 0;
                        data.map((item) => {
                            if (item.requestStatus === "Approved") {
                                approved += 1;
                            } else if (item.requestStatus === "Pending") {
                                pending += 1;
                            } else {
                                rejected += 1
                            }
                            if (
                                participantList.indexOf(item.participant) == -1
                            ) {
                                participantList.push(item.participant);
                            }
                            allrequestData.push({
                                actualData: item,
                                row: [
                                    {
                                        label: 'checkbox',
                                        key: 'draftTransportID',
                                        draftTransportID: item.draftTransportID,
                                        width: '0.05',
                                    },
                                    {
                                        label: 'Participant',
                                        key: 'participant',
                                        participant: item.participant,
                                        width: '0.25',
                                        showLabel: false,
                                        addLink: false,
                                        toEmail: item.email,
                                        showEmail: true,
                                        type: item.transportType,
                                        alignCenter: true,
                                        showEventType: true,
                                        eventType:
                                            item.isGroundTransport ? 'Ground Transport' : item.transportType.toLowerCase() === 'air'
                                                ? `Event ${item.tripInfoType ===
                                                    'arrival'
                                                    ? 'Arrival'
                                                    : 'Departure'
                                                }`
                                                : '',
                                    },
                                    // {
                                    //     label: 'Person Name',
                                    //     key: 'personName',
                                    //     personName: item.passangerName,
                                    //     width: '0.15',
                                    //     inColumn: true,
                                    //     // alignCenter: true,
                                    // },
                                    {
                                        label: 'Submitted By',
                                        key: 'submittedBy',
                                        submittedBy: item.submittedBy,
                                        width: '0.15',
                                        inColumn: true,
                                        // alignCenter: true,
                                    },
                                    {
                                        label: 'Submitted Date',
                                        key: 'date',
                                        date: Helper.FormatDateTime(item.date),
                                        width: '0.15',
                                        inColumn: true,
                                    },
                                    // {
                                    //     label: 'Modified Date',
                                    //     key: 'lastModifiedDate',
                                    //     lastModifiedDate: !Helper.IfDateIsNULL(
                                    //         item.lastModifiedDate
                                    //     )
                                    //         ? Helper.FormatDateTime(
                                    //             item.lastModifiedDate
                                    //         )
                                    //         : '',
                                    //     width: '0.15',
                                    //     inColumn: true,
                                    // },
                                    {
                                        label: 'History',
                                        key: 'auditHistory',
                                        auditHistory: "",
                                        width: '0.05',
                                        showLabel: false,
                                        showChips: false,
                                        inColumn: true,
                                    },
                                    {
                                        label: 'Shared',
                                        key: 'sharedWithVendor',
                                        sharedWithVendor: item.sharedWithVendor,
                                        width: '0.05',
                                        showSwitch: true,
                                        inColumn: true,
                                        alignCenter: true,
                                    },
                                    {
                                        label: 'Status',
                                        key: 'requestStatus',
                                        requestStatus: item.requestStatus,
                                        width: '0.05',
                                        showStatusIcon: true,
                                        inColumn: true,
                                        alignCenter: true,
                                    },
                                    {
                                        label: 'Action',
                                        key: 'All',
                                        all: 'All',
                                        width: '0.1',
                                    },
                                ],
                                selected: false,
                                expanded: false,
                            });
                        });
                        fullData.set(allrequestData)
                        setFilters({
                            // transportType: ['Air', 'Ground'],
                            participant: participantList,
                            requestStatus: statusList.attach(Downgraded).get(),
                        });
                        data.slice(indexOfFirstRecord, indexOfLastRecord).map((item) => {
                            requestData.push({
                                actualData: item,
                                row: [
                                    {
                                        label: 'checkbox',
                                        key: 'draftTransportID',
                                        draftTransportID: item.draftTransportID,
                                        width: '0.05',
                                    },
                                    {
                                        label: 'Participant',
                                        key: 'participant',
                                        participant: item.participant,
                                        width: '0.25',
                                        showLabel: false,
                                        addLink: false,
                                        toEmail: item.email,
                                        showEmail: true,
                                        type: item.transportType,
                                        alignCenter: true,
                                        showEventType: true,
                                        eventType:
                                            item.isGroundTransport ? 'Ground Transport' : item.transportType.toLowerCase() === 'air'
                                                ? `Event ${item.tripInfoType ===
                                                    'arrival'
                                                    ? 'Arrival'
                                                    : 'Departure'
                                                }`
                                                : '',

                                    },
                                    // {
                                    //     label: 'Person Name',
                                    //     key: 'personName',
                                    //     personName: item.passangerName,
                                    //     width: '0.15',
                                    //     inColumn: true,
                                    //     // alignCenter: true,
                                    // },
                                    {
                                        label: 'Submitted By',
                                        key: 'submittedBy',
                                        submittedBy: item.submittedBy,
                                        width: '0.20',
                                        inColumn: true,
                                        // alignCenter: true,
                                    },
                                    {
                                        label: 'Submitted Date',
                                        key: 'date',
                                        date: Helper.FormatDateTime(item.date),
                                        width: '0.25',
                                        inColumn: true,
                                    },
                                    // {
                                    //     label: 'Modified Date',
                                    //     key: 'lastModifiedDate',
                                    //     lastModifiedDate: !Helper.IfDateIsNULL(
                                    //         item.lastModifiedDate
                                    //     )
                                    //         ? Helper.FormatDateTime(
                                    //             item.lastModifiedDate
                                    //         )
                                    //         // +
                                    //         // ' ' +
                                    //         // Helper.FormatTime(
                                    //         //     item.lastModifiedDate
                                    //         // )
                                    //         : '',
                                    //     width: '0.15',
                                    //     inColumn: true,
                                    //     // alignCenter: true,
                                    // },
                                    {
                                        label: 'History',
                                        key: 'auditHistory',
                                        auditHistory: "",
                                        width: '0.05',
                                        showLabel: false,
                                        showChips: false,
                                        inColumn: true,
                                        // alignCenter: true,
                                    },
                                    {
                                        label: 'Shared',
                                        key: 'sharedWithVendor',
                                        sharedWithVendor: item.sharedWithVendor,
                                        width: '0.05',
                                        showSwitch: true,
                                        inColumn: true,
                                        alignCenter: true,
                                    },
                                    {
                                        label: 'Status',
                                        key: 'requestStatus',
                                        requestStatus: item.requestStatus,
                                        width: '0.05',
                                        showStatusIcon: true,
                                        inColumn: true,
                                        alignCenter: true,
                                    },

                                    // {
                                    //     label: 'Status',
                                    //     key: 'status',
                                    //     status: item.status
                                    //         ? 'Active'
                                    //         : 'Inactive',
                                    //     width: '0.1',
                                    // },
                                    {
                                        label: 'Action',
                                        key: 'All',
                                        all: 'All',
                                        width: '0.1',
                                    },
                                ],
                                selected: false,
                                expanded: false,
                            });
                        });
                        setShowStatus({ Approved: approved, Pending: pending, Rejected: rejected })
                    } else {
                        setShowStatus({ Approved: 0, Pending: 0, Rejected: 0 })
                    }
                    setShowSearchRec(false);
                    let filterData = filteredList.attach(Downgraded).get();
                    if (filterData.length > 0) {
                        setFilterChangeVal(false)
                    }
                    allData.set(requestData);
                    allListData.set(requestData);
                    loading.set(false);

                    if (pagingInfo.get().noOfPages == null) {
                        pagingInfo.set({
                            ...pagingInfo,
                            currentPage: pagingInfo.get().currentPage,
                            itemsPerPage: pagingInfo.get().itemsPerPage,
                            noOfPages: Math.ceil(
                                res.data.totalCount /
                                pagingInfo.get().itemsPerPage
                            ),
                        });
                    }
                }
            })
            .catch((error) => {
                loading.set(false);
                if (error.response && error.response.status === 401) {
                    alert(error);
                }
            });
    };

    const onSharedVendor = (isChecked, draftTransportID, userID) => {
        ApiHelper.get(
            APIURLConstants.GET_SHARED_ADMIN_DRAFT_TRANSPORT_LIST(
                draftTransportID,
                isChecked,
                userID
            )
        )
            .then(async (res) => {
                if (res.data) {
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Request updated successfully',
                    });
                    loading.set(false);
                    //await getEmailNotification(draftTransportID);
                    //getAdminTransportList();
                }
            })
            .catch((error) => {
                loading.set(false);
                if (error.response && error.response.status === 401) {
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: 'Access denied',
                    });
                } else {
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: 'Error while creating request',
                    });
                }
            });
    };

    const filterListData = (data) => {
        filteredList.set(data);
    };
    const callExport = () => {
        if (filteredList.attach(Downgraded).length !== 0) {
            const selected = filteredList
                .get()
                .filter((user) => user.selected === true);
            const allSelected = filteredList
                .get()
                .filter((user) => user.selected === false);

            if (selected.length === 0) {
                generateExcelReport(allSelected);
            } else {
                generateExcelReport(selected);
            }
        } else {
            const selected = allData
                .get()
                .filter((user) => user.selected === true);
            const allSelected = fullData
                .get()
                .filter((user) => user.selected === false);

            if (selected.length === 0) {
                generateExcelReport(allSelected);
            } else {
                generateExcelReport(selected);
            }
        }
    };

    const handleConfirmation = () => {
        let deleteRequests = [];
        allData.get().map((row) => {
            if (row.selected === true) {
                deleteRequests.push(row.actualData.draftTransportID);
            }
        });
        fullData.get().map((row) => {
            if (row.selected === true) {
                deleteRequests.push(row.actualData.draftTransportID);
            }
        });

        ApiHelper.post(APIURLConstants.DELETE_DRAFT_TRANSPORT, {
            Ids: deleteRequests.join(','),
            Delete: true,
            ModifiedBy: userID.value,
        })
            .then((res) => {
                if (res.data) {
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Request deleted successfully',
                    });
                    // onDelete(false);
                    setAll.set(false);
                    getAdminTransportList();
                }
            })
            .catch((error) => {
                let message = '';
                if (error.response && error.response.status === 401) {
                    message = 'Access denied';
                } else {
                    message = 'Error while deleting request';
                }
                setSnackBarProps({
                    ...snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: message,
                });
            });
        deleteConfirmation.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            message: '',
        });
    };

    const handlePendingAction = () => {
        pendingAction.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            message: '',
        });
        console.log(requestPending.get().addedFor)
        ApiHelper.get(
            APIURLConstants.GET_STATUS_ADMIN_DRAFT_TRANSPORT_LIST(
                requestPending.get().draftTransportID,
                requestPending.get().status,
                requestPending.get().userID,
                1
            )
        ).then((res) => {
            if (res.data) {
                rejectloading.set({
                    loading: false,
                    index: 0
                })
                approveloading.set({
                    loading: false,
                    index: 0
                })
                pendingAction.set({
                    open: false,
                    title: '',
                    OkButtonText: 'Ok',
                    message: '',
                });
                getAdminTransportList();
                console.log(participantList)
                let published = {}
                participantList.filter((item) => item.userID === requestPending.get().addedFor
                ).map((x) => {
                    published = { isPublished: x.isPublished }
                })
                //                 if(published.isPublished){
                // getEmailNotification(requestPending.get().draftTransportID);
                //                 }
                requestPending.set(null);
            }
        });
    };

    // const generateExcelReport = (result) =>
    // {
    //     const header = {
    //         participant: 'Participant',
    //         submittedBy: 'Submitted By',
    //         date: 'Date',
    //         lastModified: 'Last Modified',
    //         shared: 'Shared',
    //         status: 'Status',
    //         fromLocation: 'From Location',
    //         fromDate: 'From Date',
    //         toLocation: 'To Location',
    //         toDate: 'To Date',
    //         transportType: 'Transport Type',
    //         tripInfoType: 'Trip Info Type',
    //         notes: 'Notes'
    //     };

    //     let data = [];
    //     result.forEach((res) =>
    //     {
    //         const row = res.actualData;
    //         data.push({
    //             participant: row.participant,
    //             submittedBy: row.submittedBy,
    //             date: Helper.FormatDate(row.date),
    //             lastModified: !Helper.IfDateIsNULL(row.lastModifiedDate)
    //                 ? Helper.FormatDate(row.lastModifiedDate) +
    //                 ' ' +
    //                 Helper.FormatTime(row.lastModifiedDate)
    //                 : '',
    //             shared: row.sharedWithVendor,
    //             status: row.requestStatus,
    //             fromLocation: row.fromLocation,
    //             fromDate: Helper.FormatDate(row.fromDate),
    //             toLocation: row.toLocation,
    //             toDate: Helper.FormatDate(row.toDate),
    //             transportType: row.transportType,
    //             tripInfoType: row.tripInfoType,
    //             notes: row.note
    //         });
    //     });

    //     data.unshift(header);
    //     Helper.downloadReport(
    //         data,
    //         // `Transport-${Helper.FormatMonthWithDateTime(new Date())}`,
    //         `Transport-Report`,
    //     );
    //     // setAll.set(false);
    // };

    const generateExcelReport = async (result) => {
        let selectedIds = [];
        let IDs = null;
        if (result.length > 0) {
            result.map((item) => {
                selectedIds.push(item.actualData.draftTransportID);
            });
            IDs = selectedIds.join(',');
        }

        await ApiHelper.post(
            APIURLConstants.Excel_Export, { EventID: eventData.get().eventID, ModuleID: 20, IDs: IDs }
        ).then((res) => {
            const finalObject = JSON.parse(res.data.value);
            if (finalObject) {
                if (finalObject.length > 0) {
                    let header = {};
                    Object.keys(finalObject[0]).map((key) => {
                        header[key] = key;
                    });

                    finalObject.unshift(header);
                    Helper.downloadReport(finalObject, `Transport-Report`);
                }
            }
        });
    };

    const handlePageChange = (event, page) => {
        pagingInfo.set({
            ...pagingInfo,
            currentPage: page,
            itemsPerPage: pagingInfo.get().itemsPerPage,
            noOfPages: pagingInfo.get().noOfPages,
        });
        getAdminTransportList();
    };

    const getParticipantList = () => {
        const gEventInfo = Helper.getStorage('eventInfo');
        const gUserInfo = Helper.getStorage('userInfo');
        if (
            Helper.isAdminUser(gUserInfo) ||
            (gUserInfo.roles && Helper.isEventAdmin(gUserInfo) || (gUserInfo.roles && Helper.isEventStaff(gUserInfo)))
        ) {
            ApiHelper.get(
                APIURLConstants.GET_ADMIN_EVENT_PARTICIPANTS(gEventInfo.eventID)
            ).then((res) => {
                if (res.data) {
                    const participants = res.data.rows.filter(
                        (participant) =>
                            AppConstants.EVENT_ROLES_VALUES.indexOf(
                                participant.roleName
                            ) == -1
                    );
                    setParticipantList(participants);
                }
            });
        }
    }

    const onSharedToggleChange = (event, findex, item) => {
        let newData = allData.attach(Downgraded).get();
        let index = newData.findIndex(
            (data) => data.actualData.draftTransportID == item.actualData.draftTransportID
        );
        let newItem = newData[index];
        newItem.actualData.sharedWithVendor = event.target.checked;
        const shareIndex = newItem.row.findIndex(
            (rw) => rw.key == 'sharedWithVendor'
        );
        newItem.row[shareIndex].sharedWithVendor = event.target.checked;
        allData[index].set(newItem);
        const isChecked = event.target.checked ? 1 : 0;
        onSharedVendor(isChecked, item.actualData.draftTransportID, userID.get());
    };
    const onToggleChange = (item, index) => {
        item.expanded = !item.expanded;
        allData[index].set(item);
        fullData[index].set(item);
    }
    const onActionClick = (item, index, action) => {
        if (action == 'Approve') {
            approveloading.set({
                loading: true,
                index: index
            })
        }
        else if (action == 'Reject') {
            rejectloading.set({
                loading: true,
                index: index
            })
        }
        let newData = [...allData.attach(Downgraded).get()];
        let Index = newData.findIndex(
            (data) => data.actualData.draftTransportID == item.actualData.draftTransportID
        );
        let newItem = newData[Index].actualData;

        const isStatus = action == 'Approve' ? 2 : action == 'Reject' ? 3 : 1;
        requestNote.set({
            noteID: newItem.noteID,
            draftTransportID: newItem.draftTransportID,
            status: isStatus,
            userID: userID.get(),
            action,
            item: newItem,
            index,
            note: "",
        });
        openNoteDialog.set(true);
    };

    const closeNoteDialog = () => {
        approveloading.set({
            loading: false,
            index: 0
        })
        rejectloading.set({
            loading: false,
            index: 0
        })
        openNoteDialog.set(false);
        requestNote.set(null);
    };

    const updateNote = async (value) => {
        let newRequestNote = { ...requestNote.attach(Downgraded).get() };
        newRequestNote['note'] = value;
        const statusUpdate = ApiHelper.get(
            APIURLConstants.GET_STATUS_ADMIN_DRAFT_TRANSPORT_LIST(
                newRequestNote.draftTransportID,
                newRequestNote.status,
                newRequestNote.userID,
                0
            )
        );
        const req = {
            NoteID: newRequestNote.noteID,
            draftTransportID: newRequestNote.draftTransportID,
            Note: newRequestNote.note,
            AddedBy: newRequestNote.userID,
        };

        const noteUpdate = ApiHelper.post(
            APIURLConstants.POST_DRAFT_TRANSPORT_NOTE,
            req
        );

        await Promise.all([statusUpdate, noteUpdate]).then(async (data) => {
            const [first, second] = data;
            if (first && second) {
                approveloading.set({
                    loading: false,
                    index: 0
                })
                rejectloading.set({
                    loading: false,
                    index: 0
                })
                setSnackBarProps({
                    ...snackBarProps,
                    openSnack: true,
                    variant: 'success',
                    message: 'Status updated successfully',
                });
                let published = {}
                participantList.filter((item) => item.userID === newRequestNote.item.userID).map((x) => {
                    published = { isPublished: x.isPublished }
                })
                //                 if(published.isPublished){
                // getEmailNotification(req.draftTransportID);
                //                 }
                getAdminTransportList();
                if (eventData.get().readonlyOrHide === 0 && published.isPublished) {
                    saveAppNotification(newRequestNote);
                }
                closeNoteDialog();

            }
        });
    };
    const saveAppNotification = (obj) => {
        let payLoad = {
            appNotificationID: 0,
            userIDs: JSON.stringify(obj.item.userID),
            appNotificationTypeID: 1,
            eventID: eventData.get().eventID,
            moduleID: 20,
            recordRefID: obj.draftTransportID,
            requestStatus: obj.status,
            status: 0,
            createdBy: userID.get(),
        };
        ApiHelper.post(APIURLConstants.SAVE_APP_NOTIFICATION, payLoad).then(res => {
            console.log(res);
            ApiHelper.get(
                APIURLConstants.GET_MOBILE_PUSH_NOTIFICATION(
                    obj.item.userID,
                    eventData.get().eventID,
                    eventData.get().eventName,
                    displayName.get(),
                    obj.status === 2 ? "Approved" : obj.status === 3 ? "Rejected" : "Pending"
                )
            ).then((res) => {
                console.log(res);
            });
        }).catch(err => {
            console.log(err);
        })
    }
    // const getEmailNotification = async (draftTransportID) =>
    // {
    //     const userInfo = Helper.getStorage('userInfo');
    //     ApiHelper.get(
    //         APIURLConstants.GET_DRAFT_TRANSPORT_MASTER(
    //             eventData.get().eventID,
    //             draftTransportID
    //         )
    //     ).then((res) =>
    //     {
    //         if (res.data)
    //         {
    //             let form = new FormData();
    //             form.append('UserID', res.data.userID);
    //             form.append('EventID', res.data.eventID);
    //             form.append(
    //                 'TemplateType',
    //                 res.data.templateType == 'DraftTransportationGround'
    //                     ? res.data.templateType
    //                     : 'DraftTransportationAir'
    //             );
    //             form.append('ID', res.data.id);
    //             form.append('ModifyBy', userInfo.userID);
    //             form.append('TranportType', res.data.tranportType === "departure" ? "draftdeparture" : "draftarrival");
    //             form.append('ModuleID', 20);

    //             return ApiHelper.post(APIURLConstants.POST_EMAIL_NOTIFICATION, form)
    //                 .then((result) =>
    //                 {
    //                     return result.data;
    //                 })
    //                 .catch((err) =>
    //                 {
    //                     console.log(err);
    //                 });
    //         }
    //     });
    // };
    // const getMultiEmailNotification = async (multiUsers, requestIds, templateType, transportType) =>
    // {
    //     const eventInfo = Helper.getStorage('eventInfo');
    //     multiUsers.map((user, index) =>
    //     {
    //         let form = new FormData();
    //         form.append('UserID', user);
    //         form.append('EventID', eventInfo.eventID)
    //         form.append('TemplateType', templateType[index] ==
    //             "ground" ? 'DraftTransportationGround'
    //             : 'DraftTransportationAir')
    //         form.append('ID', requestIds[index])
    //         form.append('ModifyBy', userID.value)
    //         form.append('TranportType', transportType[index] == "arrival" || transportType[index] == "departure" ? transportType[index] : 'ground')
    //         form.append('ModuleID', 20)
    //         return ApiHelper.post(
    //             APIURLConstants.POST_EMAIL_NOTIFICATION,
    //             form
    //         )
    //             .then((result) =>
    //             {
    //                 return result.data;
    //             })
    //             .catch((err) =>
    //             {
    //                 console.log(err);
    //             });
    //     })
    // }

    const redirectToTransit = (data) => {
        const row = data.actualData;
        const path = generatePath(RouteConstants.DRAFT_EVENT_EDIT_TRANSIT, {
            eventID: eventData.eventID.value,
            transitID: row.draftTransportID,
        });

        history.push({
            pathname: path,
            state: { transitType: row.transportType },
        });
    };

    const onAddRequest = () => {
        handleAction('air')
        // openDialog.set(true);
    };

    const handleClose = () => {
        openDialog.set(false);
    };
    const hanldeAllNoteValue = (item) => {
        setAllNoteValue(item)
    }
    const onDelete = () => {
        const selected = allData
            .attach(Downgraded)
            .get()
            .filter((user) => user.selected === true);
        const selected1 = fullData
            .attach(Downgraded)
            .get()
            .filter((user) => user.selected === true);
        if (selected.length === 0 && selected1.length === 0) {
            setSnackBarProps({
                ...snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select request first',
            });
        } else {
            let message = setAll.get()
                ? 'Do you want to delete all request?'
                : 'Do you want to delete selected request?';

            deleteConfirmation.set({
                open: true,
                title: '',
                OkButtonText: 'Ok',
                message: message,
            });
        }
    };

    const onPendingAction = (item, index) => {
        if (item.actualData.requestStatus == 'Approved') {
            approveloading.set({
                loading: true,
                index: index
            })
        }
        else if (item.actualData.requestStatus == 'Rejected') {
            rejectloading.set({
                loading: true,
                index: index
            })
        }
        let newData = [...allData.attach(Downgraded).get()];
        let Index = newData.findIndex(
            (data) => data.actualData.draftTransportID == item.actualData.draftTransportID
        );
        let newItem = newData[Index].actualData;

        const isStatus = 1;
        requestPending.set({
            addedFor: newItem.userID,
            status: isStatus,
            userID: userID.get(),
            draftTransportID: newItem.draftTransportID,
        });

        let message = 'Do you want to move request to pending?';

        pendingAction.set({
            open: true,
            title: '',
            OkButtonText: 'Ok',
            message: message,
        });
    };

    const handleAction = (value) => {
        transittype.set(value);
        history.push({
            pathname: generatePath(RouteConstants.DRAFT_EVENT_CREATE_TRANSIT, {
                eventID: eventData.eventID.value,
            }),
            state: { transitType: value },
        });
        openDialog.set(false);
    };
    const renderDialogContent = () => {
        return <StyledTable1 rowHeader={headers}
            data={transportHistory}
        />
    }

    const renderDialogActions = () => {

    }
    const getTransportHistory = (id, transportType, isGroundTransport) => {

        if (isGroundTransport) {
            setHeaders(groundHeaders);
        } else if (transportType == 'Air') {
            setHeaders(airHeaders)
        }
        ApiHelper.get(APIURLConstants.GET_DRAFT_TRANSPORT_HISTORY(id, transportType))
            .then(res => {
                console.log(transportType)
                let arr = []
                res.data.map((item, index, originalArr) => {
                    // console.log('item', item.specialRequest);
                    let previous = originalArr[index - 1]

                    if (isGroundTransport) {
                        arr.push({
                            actualData: item,
                            row: [
                                {
                                    IsGroundTransport: item.isGroundTransport ? "Yes" : "No",
                                    highlight: index > 0 ? previous?.IsGroundTransport !== item.IsGroundTransport ? true : false : false
                                },
                                {
                                    pickupAddress: item.groundPickupAddress,
                                    highlight: index > 0 ? previous?.groundPickupAddress !== item.groundPickupAddress ? true : false : false
                                },
                                {
                                    dropoffAddress: item.groundDropoffAddress,
                                    highlight: index > 0 ? previous?.groundDropoffAddress !== item.groundDropoffAddress ? true : false : false
                                }, 
                                {
                                    shared: item.shared ? 'Yes' : 'No',
                                    highlight: index > 0 ? previous?.shared !== item.shared ? true : false : false
                                },
                                {
                                    auditBy: item.auditBy ? item.auditBy : '',
                                    highlight: index > 0 ? previous?.auditBy !== item.auditBy ? true : false : false
                                },
                                {
                                    auditDate: Helper.FormatDateTime(item.auditDate),
                                    highlight: index > 0 ? previous?.auditDate !== item.auditDate ? true : false : false
                                },
                                {
                                    auditStatus: item.auditStatus,
                                    highlight: index > 0 ? previous?.auditStatus !== item.auditStatus ? true : false : false
                                },
                                {
                                    requestStatus: item.requestStatus,
                                    highlight: index > 0 ? previous?.requestStatus !== item.requestStatus ? true : false : false
                                },
                            ]
                        })

                    } else if (transportType == 'Air') {
                        arr.push({
                            actualData: item,
                            row: [
                                {
                                    transportType: item.transportType,
                                    highlight: index > 0 ? previous?.transportType !== item.transportType ? true : false : false
                                },
                                {
                                    tripInfoType: item.tripInfoType,
                                    highlight: index > 0 ? previous?.tripInfoType !== item.tripInfoType ? true : false : false
                                },
                                {
                                    passengerName: item.passengerName,
                                    highlight: index > 0 ? previous?.passengerName !== item.passengerName ? true : false : false
                                },
                                {
                                    passengerEmail: item.passengerEmail,
                                    highlight: index > 0 ? previous?.passengerEmail !== item.passengerEmail ? true : false : false
                                },
                                {
                                    passengerContactNo: item.passengerContactNo,
                                    highlight: index > 0 ? previous?.passengerContactNo !== item.passengerContactNo ? true : false : false
                                },
                                {
                                    gender: item.gender,
                                    highlight: index > 0 ? previous?.gender !== item.gender ? true : false : false
                                },
                                {
                                    shared: item.shared ? 'Yes' : 'No',
                                    highlight: index > 0 ? previous?.shared !== item.shared ? true : false : false
                                },
                                {
                                    totalPassengers: item.totalPassengers,
                                    highlight: index > 0 ? previous?.totalPassengers !== item.totalPassengers ? true : false : false
                                },
                                {
                                    dob: Helper.FormatDate(item.dob),
                                    highlight: index > 0 ? Helper.FormatDate(previous?.dob) !== Helper.FormatDate(item.dob) ? true : false : false
                                },
                                {
                                    airline: item.airline,
                                    highlight: index > 0 ? previous?.airline !== item.airline ? true : false : false
                                },
                                {
                                    flightNo: item.flightNo,
                                    highlight: index > 0 ? previous?.flightNo !== item.flightNo ? true : false : false
                                },
                                {
                                    arrivalAirport: item.arrivalAirport,
                                    highlight: index > 0 ? previous?.arrivalAirport !== item.arrivalAirport ? true : false : false
                                },
                                {
                                    departureAirport: item.departureAirport,
                                    highlight: index > 0 ? previous?.departureAirport !== item.departureAirport ? true : false : false
                                },
                                {
                                    dateTime: item.tripInfoType === 'arrival' ? item.arrivalDate !== null ? Helper.FormatDateTime(item.arrivalDate) : "" :
                                        item.departureDate !== null ? Helper.FormatDateTime(item.departureDate)
                                            : '',
                                    highlight: index > 0 ? previous?.departureDate !== item.departureDate || previous?.arrivalDate !== item.arrivalDate ? true : false : false
                                },
                                {
                                    tsa: item.tsa,
                                    highlight: index > 0 ? previous?.tsa !== item.tsa ? true : false : false
                                },
                                {
                                    comments: item.comments,
                                    highlight: index > 0 ? previous?.comments !== item.comments ? true : false : false
                                }, 
                                {
                                    auditBy: item.auditBy ? item.auditBy : '',
                                    highlight: index > 0 ? previous?.auditBy !== item.auditBy ? true : false : false
                                },
                                {
                                    auditDate: Helper.FormatDateTime(item.auditDate),
                                    highlight: index > 0 ? previous?.auditDate !== item.auditDate ? true : false : false
                                },
                                {
                                    auditStatus: item.auditStatus,
                                    highlight: index > 0 ? previous?.auditStatus !== item.auditStatus ? true : false : false
                                },
                                {
                                    requestStatus: item.requestStatus,
                                    highlight: index > 0 ? previous?.requestStatus !== item.requestStatus ? true : false : false
                                },

                            ]
                        })
                    }
                })
                console.log(arr)
                setTransportHistory(arr)
            }).catch(err => {
                console.log(err)
                setTransportHistory([])
            })

    }

    const showTransportHistory = (item) => {        
        setShowHistory(true)
        getTransportHistory(item.actualData.draftTransportID, item.actualData.transportType, item.actualData.isGroundTransport)

    }
    const multiApprove = () => {
        const selected = allData
            .attach(Downgraded)
            .get()
            .filter((user) => user.selected === true);
        const selected1 = fullData
            .attach(Downgraded)
            .get()
            .filter((user) => user.selected === true);
        if (selected.length === 0 && selected1.length === 0) {
            setSnackBarProps({
                ...snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select request first',
            });
        } else {
            let message = setAll.get()
                ? 'Do you want to Approve all request?'
                : 'Do you want to Approve selected request?';
            allNote.set(true)
            approveConfirmation.set({
                open: true,
                title: '',
                OkButtonText: 'Ok',
                message: message,
            });
        }
    }
    const multiReject = () => {
        const selected = allData
            .attach(Downgraded)
            .get()
            .filter((user) => user.selected === true);
        const selected1 = fullData
            .attach(Downgraded)
            .get()
            .filter((user) => user.selected === true);
        if (selected.length === 0 && selected1.length === 0) {
            setSnackBarProps({
                ...snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select request first',
            });
        } else {
            let message = setAll.get()
                ? 'Do you want to Reject all request?'
                : 'Do you want to Reject selected request?';
            allNote.set(true)
            rejectConfirmation.set({
                open: true,
                title: '',
                OkButtonText: 'Ok',
                message: message,
            });
        }
    }
    // const multisaveAppNotification = (multiUsers, requestIds, status) =>
    // {
    //     let bulkNotificationItem=[];
    //     multiUsers.map((user, index) =>
    //     {
    //         bulkNotificationItem.push(JSON.stringify(user))
    //         let payLoad = {
    //             appNotificationID: 0,
    //             userIDs: JSON.stringify(user),
    //             appNotificationTypeID: 1,
    //             eventID: eventData.get().eventID,
    //             moduleID: 20,
    //             recordRefID: requestIds[index],
    //             requestStatus: status,
    //             status: 0,
    //             createdBy: userID.get(),
    //         };
    //         ApiHelper.post(APIURLConstants.SAVE_APP_NOTIFICATION, payLoad).then(res =>
    //         {
    //             console.log(res);
    //             ApiHelper.get(
    //                 APIURLConstants.GET_MOBILE_PUSH_NOTIFICATION(
    //                     user,
    //                     eventData.get().eventID,
    //                     eventData.get().eventName,
    //                     "DraftTransportation",
    //                     status === 2 ? "Approved" : status === 3 ? "Rejected" : "Pending"
    //                 )
    //             ).then((res) =>
    //             {
    //                 console.log(res);
    //             });
    //         }).catch(err =>
    //         {
    //             console.log(err);
    //         })
    //     })
    // }
    const handleRejectConfirmation = () => {
        let rejectRequests = [];
        // let multiUsers = [];
        // let transportType = [];
        // let templateType = []
        allData.get().map((row) => {
            if (row.selected === true) {
                //rejectRequests.push(row.actualData.draftTransportID);
                rejectRequests.push({
                    userID: row.actualData.userID,
                    iD: row.actualData.draftTransportID,
                    transportType: row.actualData.tripInfoType != "SUV" ? "TransportationAir" : "TransportationGround"
                })
                // multiUsers.push(row.actualData.userID)
                // templateType.push(row.actualData.transportType)
                // transportType.push(row.actualData.tripInfoType)
            }
        });
        fullData.get().map((row) => {
            if (row.selected === true) {
                //rejectRequests.push(row.actualData.draftTransportID);
                rejectRequests.push({
                    userID: row.actualData.userID,
                    iD: row.actualData.draftTransportID,
                    transportType: row.actualData.tripInfoType != "SUV" ? "TransportationAir" : "TransportationGround"
                })
                // multiUsers.push(row.actualData.userID)
                // templateType.push(row.actualData.transportType)
                // transportType.push(row.actualData.tripInfoType)
            }
        });
        const eventInfo = Helper.getStorage('eventInfo');
        rejectLoader.set(true)
        ApiHelper.post(APIURLConstants.UPDATE_MULTI_SELECT_STATUS, {
            Ids: JSON.stringify(rejectRequests),//rejectRequests.join(','),
            Status: 3,
            Note: allNoteValue,
            EventID: eventInfo.eventID,
            ModuleID: 20,
            ModifiedBy: userID.value,
            TemplateType: "DraftTransport",
            TransportType: "",
            appNotificationTypeID: 1
        })
            .then((res) => {
                if (res.data) {
                    rejectLoader.set(false)
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Request rejected successfully',
                    });
                    setAll.set(false);
                    setAllNoteValue('')
                    getAdminTransportList();
                    // getMultiEmailNotification(multiUsers, rejectRequests, templateType, transportType)
                    // if (eventData.get().readonlyOrHide === 0)
                    // {
                    //     multisaveAppNotification(multiUsers, rejectRequests, 3);
                    // }
                }
            })
            .catch((error) => {
                rejectLoader.set(false)

                if (error.response && error.response.status === 401) {
                    let message = 'Access denied';
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: message,
                    });
                } else if (error.response && error.response.status === 502) {
                    let message = 'Request rejected successfully';
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: message,
                    });
                } else {
                    let message = 'Error while reject request';
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: message,
                    });
                }
            });
        rejectConfirmation.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            message: '',
        });

    }
    const handleApproveConfirmation = () => {
        let approveRequests = [];
        // let multiUsers = [];
        // let transportType = [];
        // let templateType = []
        fullData.get().map((row) => {
            if (row.selected === true) {
                approveRequests.push({
                    userID: row.actualData.userID,
                    iD: row.actualData.draftTransportID,
                    transportType: row.actualData.tripInfoType != "SUV" ? "TransportationAir" : "TransportationGround"
                });
                //approveRequests.push(row.actualData.draftTransportID);
                // multiUsers.push(row.actualData.userID);
                // templateType.push(row.actualData.transportType)
                // transportType.push(row.actualData.tripInfoType)
            }
        });
        allData.get().map((row) => {
            if (row.selected === true) {
                approveRequests.push({
                    userID: row.actualData.userID,
                    iD: row.actualData.draftTransportID,
                    transportType: row.actualData.tripInfoType != "SUV" ? "TransportationAir" : "TransportationGround"
                });
                // multiUsers.push(row.actualData.userID);
                // templateType.push(row.actualData.transportType)
                // transportType.push(row.actualData.tripInfoType)
            }
        });
        const eventInfo = Helper.getStorage('eventInfo');
        approveLoader.set(true)
        ApiHelper.post(APIURLConstants.UPDATE_MULTI_SELECT_STATUS, {
            Ids: JSON.stringify(approveRequests), //approveRequests.join(','),
            Status: 2,
            Note: allNoteValue,
            EventID: eventInfo.eventID,
            ModuleID: 20,
            ModifiedBy: userID.value,
            TemplateType: "DraftTransport",
            TransportType: "",
            appNotificationTypeID: 1
        })
            .then((res) => {
                // console.log("res", res)
                if (res.data) {
                    approveLoader.set(false)
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Request approved successfully',
                    });
                    setAll.set(false);
                    setAllNoteValue('')
                    getAdminTransportList();
                    // getMultiEmailNotification(multiUsers, approveRequests, templateType, transportType)
                    // if (eventData.get().readonlyOrHide === 0)
                    // {
                    //     multisaveAppNotification(multiUsers, approveRequests, 2);
                    // }
                }
            })
            .catch((error) => {
                approveLoader.set(false)
                if (error.response && error.response.status === 401) {
                    let message = 'Access denied';
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: message,
                    });
                } else if (error.response && error.response.status === 502) {
                    let message = 'Request approved successfully';
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: message,
                    });
                } else {
                    let message = 'Error while approve request';
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: message,
                    });
                }
            });
        approveConfirmation.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            message: '',
        });
    }


    return (
        <Box className={"virtusoSummaryContentBox"}>
            {
                // loading.get() ? (
                //     <Box style={loader}>
                //         <CircularProgress />
                //     </Box>
                // ) :
                modPermission && modPermission == NO_ACCESS_PERMISSION ? (
                    <UnauthorizedUI showLogout={false} />
                ) : (
                    <DataList
                        // new props
                        data={allData.attach(Downgraded).get()}
                        allData={fullData.attach(Downgraded).get()}
                        editRow={redirectToTransit}
                        handleClick={onAddRequest}
                        title={''}
                        loading={loading.get()}
                        buttonTitle={'Add'}
                        deleteRows={onDelete}
                        filterChangeVal={filterChangeVal}
                        showSearch={showSearch}
                        searchLabel={'Search'}
                        showFilter={true}
                        filters={filters}
                        showSearchRec={showSearchRec}
                        setShowSearchRec={setShowSearchRec}
                        onSwitchToggle={onSharedToggleChange}
                        onActionClick={onActionClick}
                        showSync={true}
                        showExport={true}
                        showHistory={showTransportHistory}
                        // showSettings={true}
                        callExport={callExport}
                        getResults={getAdminTransportList}
                        pagingInfo={pagingInfo.attach(Downgraded).get()}
                        handlePageChange={handlePageChange}
                        isPage={true}
                        snackBarProps={snackBarProps}
                        setSnackBarProps={setSnackBarProps}
                        onPendingAction={onPendingAction}
                        modPermission={modPermission}
                        filterListData={filterListData}
                        moduleToShow={'Draft Transportation'}
                        moduleDisplayName={Helper.getModuleName(eventData.get() ? eventData.moduleDetails.get() : [],
                            AppConstants.EVENT_MODULES.DRAFT_TRANSPORTATION)}
                        showRequestStatus={showStatus}
                        titleHeader='Transportation'
                        showApproveAndReject={true}
                        multiApprove={multiApprove}
                        multiReject={multiReject}
                        windowAccordDataList={true}
                        rowType='draftTransport'
                        onToggleChange={onToggleChange}
                        approveLoader={approveLoader.get()}
                        rejectLoader={rejectLoader.get()}
                        showShared={true}
                        approveloading={approveloading.get()}
                        rejectloading={rejectloading.get()}
                        windowDataList={true} 
                        hideReject={true}
                        hideApprove={true}
                        moduleVirtusoDataList={true}
                        showVirtusoSelectAll={true}
                    />
                )}
            {snackBarProps.openSnack && (
                <CustomizedSnackbars
                    {...snackBarProps}
                    onClose={() =>
                        setSnackBarProps({ ...snackBarProps, openSnack: false })
                    }></CustomizedSnackbars>
            )}
            {openDialog.get() && (
                <SelectTransportation
                    open={openDialog.get()}
                    title="Select Transportation Type"
                    handleClose={handleClose}
                    handleAction={handleAction}
                />
            )}
            {
                <ConfirmationDialog
                    open={deleteConfirmation.get().open}
                    message={deleteConfirmation.get().message}
                    OkButtonText={deleteConfirmation.get().OkButtonText}
                    handleCnfClick={() =>
                        handleConfirmation(deleteConfirmation)
                    }
                    onCancelClick={() => {
                        deleteConfirmation.set({
                            ...deleteConfirmation.get(),
                            open: false,
                        });
                    }}></ConfirmationDialog>
            }
            {
                <ConfirmationDialog
                    open={rejectConfirmation.get().open}
                    message={rejectConfirmation.get().message}
                    OkButtonText={rejectConfirmation.get().OkButtonText}
                    note={allNote}
                    allNoteValue={hanldeAllNoteValue}
                    handleCnfClick={() =>
                        handleRejectConfirmation(rejectConfirmation)
                    }
                    fullWidth={true}
                    onCancelClick={() => {
                        rejectConfirmation.set({
                            ...rejectConfirmation.get(),
                            open: false,
                        });
                    }}></ConfirmationDialog>
            }
            {
                <ConfirmationDialog
                    open={approveConfirmation.get().open}
                    message={approveConfirmation.get().message}
                    OkButtonText={approveConfirmation.get().OkButtonText}
                    note={allNote}
                    allNoteValue={hanldeAllNoteValue}
                    handleCnfClick={() =>
                        handleApproveConfirmation(approveConfirmation)
                    }
                    fullWidth={true}
                    onCancelClick={() => {
                        approveConfirmation.set({
                            ...approveConfirmation.get(),
                            open: false,
                        });
                    }}></ConfirmationDialog>
            }

            {
                <PendingActionDialog
                    open={pendingAction.get().open}
                    message={pendingAction.get().message}
                    OkButtonText={pendingAction.get().OkButtonText}
                    handleCnfClick={() => handlePendingAction(pendingAction)}
                    onCancelClick={() => {
                        pendingAction.set({
                            ...pendingAction.get(),
                            open: false,
                        });
                        approveloading.set({
                            loading: false,
                            index: 0
                        })
                        rejectloading.set({
                            loading: false,
                            index: 0
                        })
                    }}></PendingActionDialog>
            }
            {openNoteDialog.get() && (
                <TransportNote
                    open={openNoteDialog.get()}
                    title={`${requestNote.get().action} Note`}
                    handleClose={closeNoteDialog}
                    updateNote={updateNote}
                    data={requestNote.attach(Downgraded).get()}
                />
            )}
            {showHistory && <CustomDialog
                TransitionComponent={Transition}
                title={'Transportation History'}
                maxWidth='xl'
                handleClose={() => { setShowHistory(false); setTransportHistory(); setHeaders([]) }}
                showClose={true}
                open={showHistory}
                fullWidth={true}
                renderContent={renderDialogContent}
                renderActions={renderDialogActions}

            />}
        </Box>
    );
};

export default {
    routeProps: {
        path: RouteConstants.DRAFT_EVENT_TRANSIT_LIST,
        component: DraftTransportList,
    },
    name: 'DraftTransportList',
};
